import { Api } from '@reduxjs/toolkit/dist/query';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
export type GetApiGenericType<C extends Api<any, any, any, any, any>> =
  C extends Api<infer P, infer R, infer S, infer T, infer U>
    ? { BaseQuery: P; EndpointDefinitions: R; ReducerPath: S; Tags: T; Enhancer: U }
    : unknown;

export const formatUri = (path: string, params: Record<string, any>) =>
  path +
  '?' +
  Object.keys(params)
    .filter(key => params[key] !== undefined)
    .map(key => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
